import axiosPrivate from "@services/axiosPrivate"
import { FACEBOOK_ADSETS_URL } from "src/constants"

export const getAllAdSetsByAccountId = async (adAccountId) => {
   return axiosPrivate.get(`act_${adAccountId}/${FACEBOOK_ADSETS_URL}`, {
      params: {
         fields:
            "id,name,campaign_id,status,daily_budget",
         limit: 500,
      },
   })
}
